import { useCallback } from 'react';
import { useModal } from '../../Modal/hooks/useModal';
export var useDeletePreset = function (_a) {
    var selectedPresetName = _a.selectedPresetName, gridName = _a.gridName, gridActions = _a.gridActions, setSelectedPresetName = _a.setSelectedPresetName;
    var _b = useModal(), isDeletePresetModalOpen = _b.isOpen, onOpenDeletePresetModal = _b.onOpen, onCloseDeletePresetModal = _b.onClose, presetNameToDelete = _b.data;
    var handleOpenDeletePresetModal = useCallback(function (presetName) { return function (e) {
        if (!presetName)
            return;
        e.stopPropagation();
        onOpenDeletePresetModal(presetName);
    }; }, [selectedPresetName]);
    var handleDeletePreset = useCallback(function () {
        var _a;
        if (!gridName || !presetNameToDelete)
            return;
        (_a = gridActions.deletePreset) === null || _a === void 0 ? void 0 : _a.call(gridActions, presetNameToDelete);
        if (selectedPresetName === presetNameToDelete) {
            setSelectedPresetName('');
        }
        onCloseDeletePresetModal();
    }, [gridName, presetNameToDelete]);
    return {
        handleOpenDeletePresetModal: handleOpenDeletePresetModal,
        isDeletePresetModalOpen: isDeletePresetModalOpen,
        handleDeletePreset: handleDeletePreset,
        onCloseDeletePresetModal: onCloseDeletePresetModal,
        presetNameToDelete: presetNameToDelete
    };
};
